var _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 853.331,
    x2: 853.331,
    y1: 0,
    y2: 1706.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509804,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272 0h1162c150 0 273 123 273 272v1162c0 150-123 273-273 273h-1162c-149 0-272-123-272-273v-1162c0-149 123-272 272-272zm295 510c-37-37-94 20-57 57l195 194c-50 42-124 39-171-7l-211-212c-49-48-49-129 0-178 40-40 68-78 130-78 33 0 65 13 89 37l212 211c46 47 49 121 7 171zm194 308 128 127c-73 81-70 206 7 284l212 211c80 80 211 80 291 0 55-55 101-96 101-187 0-52-20-105-60-145l-211-212c-78-77-203-80-284-7l-127-128c73-81 70-206-8-283l-211-211c-80-81-211-81-291 0-56 55-102 95-102 186 0 53 20 106 61 146l211 211c77 78 202 81 283 8zm184 184 195 194c37 38 94-19 56-56l-194-195c50-41 124-38 170 8l212 211c49 49 49 130 0 178-41 41-68 78-131 78-32 0-64-12-89-36l-211-212c-46-46-49-120-8-170zm489-922h-1162c-105 0-192 87-192 192v1162c0 106 87 193 192 193h1162c106 0 193-87 193-193v-1162c0-105-87-192-193-192z",
    fill: "url(#id0)",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkB);
export default __webpack_public_path__ + "static/media/link_b.94972f7d10e7193ba40ebe9453e2f1d2.svg";
export { ForwardRef as ReactComponent };